import { SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountPreviewsQueryKey } from "../../previews/previews.keys";
import { accountQueryKey } from "../account.keys";

export const useReopenAccount = (accountId: SuretyAccountId) => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async () => {
			await post(`/v2/surety/accounts/${accountId}/open`, {}, "none");
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountPreviewsQueryKey() }),
			]);
		},
	});

	return {
		reopenAccount: mutation.mutate,
		reopenAccountLoading: mutation.isPending,
		reopenAccountError: mutation.error,
		dismissReopenAccountError: () => {
			mutation.reset();
		},
	};
};
